/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useCallback } from "react";
import themePropTypes from "../theme-prop-types";

const SelectWithChips = ({ name, options, onChange, fieldAttributes = {} }) => {
  const [selected, setSelected] = useState(fieldAttributes.value);
  const [highlighted, setHighlighted] = useState(-1);
  const [expanded, setExpanded] = useState(false);

  const selectHighlighted = useCallback(
    indexSelected => {
      if (highlighted >= 0) {
        const newSelected = options[highlighted].value;
        setSelected(newSelected);
        setHighlighted(-1);
        setExpanded(false);
        onChange(newSelected);
      } else if (indexSelected >= 0) {
        const newSelected = options[indexSelected].value;
        setSelected(newSelected);
        setHighlighted(indexSelected);
        setExpanded(false);
        onChange(newSelected);
      }
    },
    [setSelected, highlighted, setHighlighted, setExpanded, onChange]
  );

  const getSelected = useCallback(
    index => (options[index].value === selected ? " selected" : ""),
    [selected]
  );

  const handleKeyDown = useCallback(
    e => {
      switch (e.key) {
        case "ArrowUp":
          if (highlighted > 0) {
            setHighlighted(highlighted - 1);
          }
          break;
        case "ArrowDown":
          if (highlighted < options.length) {
            setHighlighted(highlighted + 1);
          }
          break;
        case "Enter":
          selectHighlighted();
          break;
        default:
      }
    },
    [highlighted, setHighlighted]
  );

  return (
    <div className='custom-select-wrapper-web-sdk'>
      <input
        data-testid={`custom-select-${name}`}
        name={name}
        type='text'
        className={`custom-select-web-sdk${expanded ? " expanded" : ""}`}
        value={options.find(o => o.value === selected)?.label}
        onClick={() => setExpanded(!expanded)}
        onKeyDown={handleKeyDown}
      />
      <ul
        className={`custom-select-option-list-chips-web-sdk${
          expanded ? " expanded" : ""
        }`}
      >
        {options.map((option, index) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
          <li
            key={option.value}
            className={`custom-select-option-web-sdk${
              index === highlighted ? " highlighted" : ""
            }${getSelected(index)}`}
            onClick={() => selectHighlighted(index)}
            onMouseEnter={() => setHighlighted(index)}
          >
            {option.label || <>&nbsp;</>}
          </li>
        ))}
      </ul>
    </div>
  );
};

SelectWithChips.propTypes = themePropTypes.selectWithChips;

export default SelectWithChips;
